import axios from "axios";
import i18n from "i18next";
import {
    CONTENT_CARD,
    CONTENT_STUDIO_ADMIN_QUEUE,
    CONTENT_STUDIO_ANALYTICS,
    SHARE_SOCIAL_MEDIA,
    contentStudioUrl,
} from "../../helperData/ApiAddress";

const headers = (extra) => ({
    Authorization: sessionStorage.getItem("auth")
        ? `Bearer ${sessionStorage.getItem("auth")}`
        : undefined,
    "Accept-Language": i18n.language || "fa",
    ...extra,
});

const unwrapRows = (data) =>
    Array.isArray(data) ? data : data?.results || [];

export const errorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (!data) return fallback;
    if (typeof data.detail === "string") return data.detail;
    if (typeof data.message === "string") return data.message;
    const nested = Object.values(data).flat?.()[0];
    if (typeof nested === "string") return nested;
    return fallback;
};

const toFormData = (payload) => {
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        form.append(key, value);
    });
    return form;
};

export const contentStudioApi = {
    list: (params) =>
        axios
            .get(CONTENT_CARD, { headers: headers(), params })
            .then((r) => ({
                rows: unwrapRows(r.data),
                count: r.data?.count ?? unwrapRows(r.data).length,
            })),
    detail: (id) =>
        axios.get(contentStudioUrl(id), { headers: headers() }).then((r) => r.data),
    create: (payload, onUploadProgress) =>
        axios
            .post(CONTENT_CARD, toFormData(payload), {
                headers: headers(),
                onUploadProgress,
            })
            .then((r) => r.data),
    update: (id, payload, onUploadProgress) =>
        axios
            .patch(contentStudioUrl(id), toFormData(payload), {
                headers: headers(),
                onUploadProgress,
            })
            .then((r) => r.data),
    remove: (id) => axios.delete(contentStudioUrl(id), { headers: headers() }),
    submit: (id) =>
        axios
            .post(contentStudioUrl(id, "submit"), {}, { headers: headers() })
            .then((r) => r.data),
    duplicate: (id) =>
        axios
            .post(contentStudioUrl(id, "duplicate"), {}, { headers: headers() })
            .then((r) => r.data),
    analytics: (params) =>
        axios
            .get(CONTENT_STUDIO_ANALYTICS, { headers: headers(), params })
            .then((r) => r.data),
    adminQueue: (params) =>
        axios
            .get(CONTENT_STUDIO_ADMIN_QUEUE, { headers: headers(), params })
            .then((r) => ({
                rows: unwrapRows(r.data),
                count: r.data?.count ?? unwrapRows(r.data).length,
            })),
    review: (id, decision, note) =>
        axios
            .post(
                contentStudioUrl(id, "review"),
                { decision, note },
                { headers: headers() }
            )
            .then((r) => r.data),
    like: (id) =>
        axios
            .post(contentStudioUrl(id, "likes"), {}, { headers: headers() })
            .then((r) => r.data),
    unlike: (id) =>
        axios
            .delete(contentStudioUrl(id, "likes"), { headers: headers() })
            .then((r) => r.data),
    dislike: (id) =>
        axios
            .post(contentStudioUrl(id, "dislikes"), {}, { headers: headers() })
            .then((r) => r.data),
    createShareLink: (payload) =>
        axios
            .post(SHARE_SOCIAL_MEDIA, payload, { headers: headers() })
            .then((r) => r.data),
    updateShareLink: (id, payload) =>
        axios
            .patch(`${SHARE_SOCIAL_MEDIA}${id}/`, payload, { headers: headers() })
            .then((r) => r.data),
    sendShareSms: (code, payload) =>
        axios
            .post(
                `${SHARE_SOCIAL_MEDIA}${code}/send-sms/`,
                payload,
                { headers: headers() }
            )
            .then((r) => r.data),
};

export const publicContentShareUrl = (code) => {
    const origin = "https://feedima.ir";
    const pwa = (process.env.PUBLIC_URL || "/pwa").replace(/\/$/, "") || "/pwa";
    return `${origin}${pwa}/content/share/${encodeURIComponent(code)}`;
};
